import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import store from "../store/index";

//Env var
const baseURL = process.env.VUE_APP_API_ENDPOINT_TESTING;

axios.defaults.baseURL = baseURL;

axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    config.headers.Authorization = store.getters["session/token"]
      ? store.getters["session/token"]
      : localStorage.getItem("token");
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

Vue.use(VueAxios, axios);
